import { DepositSchema } from '@/views/account/Deposit/styles/Deposit.styles';

export const depositStyles: DepositSchema = {
  inputCardHolderNameProps: {
    sx: {
      '&&': {
        bg: 'white',
        h: 10,
        fontSize: 'xs',
        px: 3,
        fontWeight: 'semibold',
        boxShadow:
          '0 1px 0 0 rgba(255, 255, 255, 0.10), 0 1px 5px 0 rgba(0, 0, 0, 0.15) inset',
        color: 'black',
      },
    },
  },
};
